export function GetQueryString(search, name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}